export default __webpack_public_path__ + "static/media/KMA-template.45433f30.png";